<script setup>
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  const i18nScope = ref('components.users_management');
  const emits = defineEmits(['closeModal', 'showToast', 'triggerSearch']);
  import { deleteUser } from '../services/UsersService';
  const { t } = useI18n();
  import { BSpinner } from 'bootstrap-vue-next';

  const props = defineProps({
    user: {
      type: Object,
      required: true
    }
  });

  const loading = ref(false);

  const deleteUserNow = async () => {
    loading.value = true;
    try {
      await deleteUser(props.user.id);
      emits('triggerSearch');
      emits('showToast', {
        type: 'success',
        message: 'delete_user_success'
      });
    } catch (error) {
      emits('showToast', {
        type: 'error',
        message: 'delete_user_error'
      });
    } finally {
      loading.value = false;
      emits('closeModal');
    }
  };
</script>

<template>
  <form>
    <h4>{{ t(`${i18nScope}.delete_are_you_sure`) }}</h4>
    <p>{{ t(`${i18nScope}.this_action_not_undoable`) }}</p>
    <br>

    {{ props.user?.firstName }} {{ props.user?.lastName }}<br>
    {{ props.user?.mail }}<br>
    <br>

    <hr>

    <div class="model-buttons" v-if="!loading">
      <Button type="button" name_button="button" class="btn btn-primary" @click.prevent="deleteUserNow">
        {{ t(`${i18nScope}.delete_user`) }}
      </Button>
      <Button type="button" name_button="button" class="btn btn-outline-secondary" @click.prevent="emits('closeModal')">
        {{ t(`${i18nScope}.user_details.cancel`) }}
      </Button>
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <BSpinner style="width: 3rem; height: 3rem;" variant="primary" v-if="loading || saving" />
    </div>
  </form>
</template>
